// sliders.js
function initSwiperSliders() {
    $(".mainSlider").each(function () {
        /*
        const thise = $(this);
        thise.find("h2").each(function () {
            const text = $(this).text();
            const textArr = text.split(" ");
            $(this).html(textArr.slice(0, -1).join(' ') + `<span>${textArr.slice(-1)}</span>`)
        })
        */
        const slider = new Swiper($(this).find(".swiper-container")[0], {
            loop: true,
            autoHeight: false,
            slidesPerView: 1,
            // autoplay: true,
            grabCursor: true,
            lazy: {
                loadPrevNext: true,
            },
            pagination: {
                el: $(this).find(".swiper-pagination"),
                clickable: true,
            },
            navigation: {
                nextEl: $(this).find(".swiper-button-next"),
                prevEl: $(this).find(".swiper-button-prev"),
            },
        });
    });
    $(".brandsSlider").each(function () {
        let sliderAccess = true;
        const thise = $(this);
        const container = thise.parent();
        let slides = thise.find(".swiper-slide");
        let slider = undefined;
        slider = new Swiper($(this).find(".swiper-container")[0], {
            loop: true,
            autoHeight: false,
            slidesPerView: 8,
            spaceBetween: 0,
            // autoplay: true,

            allowTouchMove: false,
            autoPlay: false,
            speed: 100,
            touchMoveStopPropagation: true,
            lazy: {
                loadPrevNext: true,
            },
            on: {
                init: function () {
                    slides = thise.find(".swiper-slide");
                    // checkOpacity(slides, container);
                },
                // transitionStart: () => checkOpacity(slides, container),
                transitionEnd: () => {
                    sliderAccess = true;
                    loopBrandsSlider();
                    // checkOpacity(slides, container);
                },
            },
            breakpoints: {
                // when window width is >= 320px
                1280: {
                    slidesPerView: 6
                },
                991: {
                    slidesPerView: 5
                },
                768: {
                    slidesPerView: 4
                },
                640: {
                    slidesPerView: 3
                },
            }
        });
        function loopBrandsSlider(time = 5000) {
            // if (!windowLoad) return false;
            if (typeof slider == 'undefined' || !sliderAccess) return false;            
            slider.slideNext(time)
            sliderAccess = false;
        };
        // 
        loopBrandsSlider();
        thise.fadeTo(500, 1);

    });
    function checkOpacity(slides, container) {
        // if (typeof slides == 'undefined') slides = thise.find(".swiper-slide");
        slides.removeClass("hide");
        slides.each(function () {
            const thise = $(this);
            const pos = $(this).offset().left;
            if (pos < container.offset().left) thise.addClass("hide");
            if (pos + thise.innerWidth() > container.offset().left + container.innerWidth()) thise.addClass("hide");
        })
    }
};

// sliders.js